var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "url(#pattern0_457_61)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_457_61",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_457_61",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_457_61",
    width: 100,
    height: 100,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAACG0lEQVR4nO2dwW7TUBBF/R+s2dN+rD0nXwALlqX8E0JCLWEbZAmkqkmwC0W545wrnU2iqzfjEzvZZRj+Q6Zpegt8rKoH4PCU+bWq+jBN05shNFPz+Y+Wqaqvzxc5wZfEpabm8x9l/mStWOY374ew0Hz+o5y6zf/AtyEs1Xz+ozwf+qXvXzrd59/cQjSff3ML0Xz+zS1E4vzAbVV9rqrvL/iCO8nSQukMrzz/r2t6P1/j1TKAH6kL0VzIE/bjON4sCpnvjCYLHZoLmblbI+SfH1MKYS2Pi0KaLXRoLmT5R0G3hVBI1kIoJGshFCIohM2iELJQCFkohCwUQhYKIQuFkIVCyEIhNBNijDHG/G0u/SXHlaEQslAIWSiELBRCFgohC4WQhULIQiFkoRCyUAhZKIQrF7J44JlzhyY9hYT1FBLWU0hYTyFhPYWE9RQS1lNIWE8hYT2FhPXaCREUQiMUQhYK4cqFLB545tyhSU8hYT2FhPUUEtZTSFhPIWE9hYT1FBLWU0hYTyFhvXZCBIXQCIWQhUK4ciGLB545d2jSU0hYTyFhPYWE9RQS1lNIWE8hYT2FhPUUEtZTSFivnRBBITRCIWShELJQCFkohCwUQhYKIQuFkIVCyEIhZKEQmgl57T+4F85SVQ9r7pD7Sw/K9XC3RsgtsA8Y9rBx9rvd7t2wJuM43lTVJ+AxYPDD1h5T852xWoYxxhgzrMtP12cEqjfcRYMAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/Calendar.63e65df2676425344a683ab94d4a2cc4.svg";
export { ForwardRef as ReactComponent };